import _ from 'lodash';
import React from 'react';
import { FormikProps } from 'formik';
import { FormField } from '../../../global/components/form-element/form-field';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioMiscellaneous } from '../model/clergy-bio-app-models';
import { YesNoIndicators } from '../../../global/models/api-model';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';


interface Props {
	settings: ClergyBioSettings;
	id: string;
	arrayField: string;
	formikProps: FormikProps<any>;
	employment: ClergyBioMiscellaneous;
	defaultValue: ClergyBioMiscellaneous;
	setList?: any;
}


function ClergyBioMiscellaneousItem(props: Props) {

	const { settings, arrayField, id, formikProps, setList, employment, defaultValue } = props;
	const buttonClasses = buttonStyles();

	const remove = () => {
		if (defaultValue?.id) {
			const list = _.cloneDeep(formikProps?.values[arrayField]);
			const toDelete = { ...defaultValue };
			toDelete.deleted = YesNoIndicators.Yes;
			list[id] = toDelete;
			const copy = { ...formikProps?.values };
			copy[arrayField] = list;
			setList(copy);
		} else {
			const list = formikProps?.values[arrayField];
			list.splice(Number(id), 1);
			const copy = { ...formikProps?.values };
			copy[arrayField] = list;
			setList(copy);
		}
	};

	if (employment.deleted === YesNoIndicators.Yes) {
		return null;
	}

	return (
		<>

			<FormField
				name={`${arrayField}.${id}.institutionInfo`}
				label={settings?.miscellaneousInstitutionLabel}
				component='input'
				touched={formikProps.touched}
				errors={formikProps.errors}
				required
			/>
			<FormField
				name={`${arrayField}.${id}.position`}
				label={settings.positionLabel}
				component='input'
				touched={formikProps.touched}
				errors={formikProps.errors}
				required
			/>
			<FormField
				name={`${arrayField}.${id}.dateBegan`}
				label={settings?.positionStartDateLabel}
				component='datePicker'
				touched={formikProps.touched}
				errors={formikProps.errors}
				required
				autoWidth
			/>
			<FormField
				name={`${arrayField}.${id}.dateEnded`}
				label={settings?.positionEndDateLabel}
				component='datePicker'
				touched={formikProps.touched}
				errors={formikProps.errors}
				autoWidth
			/>

			<div className='form-item'><button className={buttonClasses.linkButton} type='button' onClick={() => remove()} >{settings?.removeChildButtonText}</button></div>
		</>
	);
}

ClergyBioMiscellaneousItem.defaultProps = {
	setList: null,
};
export default ClergyBioMiscellaneousItem;